import fetch from 'isomorphic-fetch';
import {commonHeaders, commonErrorHandler} from './fetch.util';

export const JOIN_HISTORY_RESPONSE = 'JOIN_HISTORY_RESPONSE';

export function joinHistoryResponse(result) {
  return {
    type: JOIN_HISTORY_RESPONSE,
    result,
  };
}

export function fetchJoinHistory(discHash, history) {
  return dispatch => {
    fetch(`${API_URL}/users/by-duplication-information?duplicationInformation=${encodeURIComponent(discHash)}`, {
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(json => {
        dispatch(joinHistoryResponse(json));
        if (json && json.length === 0) {
          history.push('/member-service/join/form');
        }
      });
  };
}
